import { createSelector } from 'reselect'

export const loginState = state => state.login

export const isUserLoggedIn = createSelector(
  loginState,
  login => login.isLoggedIn
)
